import { environment } from '../../environments/environment';

export class UrlHelper {
    static getImageUrl(path: string): string {
        if (!path) {
            return '';
        }
        // Remove /api only from the end of the URL
        const baseUrl = environment.apiUrl.endsWith('/api')
            ? environment.apiUrl.slice(0, -4)
            : environment.apiUrl;
        const result = `${baseUrl}/${path}`;
        return result;
    }
}
